{
  "pointsBalance": {
    "noPointsMainText": "Avios is our loyalty currency. Collect or buy Avios and enter a world of countless benefits.",
    "noPointsFooterText": "Avios expire if you have no transactions at least once every 18 months.",
    "collectAvios": "How to collect avios"
  },
  "manageAvios": {
    "title": "Manage Avios"
  },
  "boostAvios": {
    "title": "Boost your Avios",
    "body": "Need a quick top-up? Multiply the Avios you collected <b>last month</b> – cheaper than buying Avios directly. You can multiply once a month. <span class=\"underline\">Learn more about boosting Avios.</span>",
    "boostNow": "Boost Avios now",
    "checkEligible": "Check your Avios eligible for boosting",
    "aviosAvailable": "Avios available",
    "mfaRequired": {
      "title": "Two factor authentication is required",
      "text": "To buy or transfer Avios, you need to enable two-factor authentication.",
      "enableNow": "Enable now"
    },
    "mfaEnabled": {
      "title": "Two-factor authentication enabled",
      "text": "You can go back and boost your Avios.",
      "manageAvios": "Manage your Avios"
    }
  }
}
